import {Component, Prop, Vue} from "vue-property-decorator";
import getImageSource from "@/helpers/getImageSource.ts";
import selectByLang from "@/helpers/selectByLang";

@Component
export default class BannerMixin extends Vue {
  @Prop({ required: true }) slideList!: object[]
  @Prop() theme!: object
  public currentIndex = 0;
  public timer = 0; //banner Timer

  public selectByLang(optionCn, optionEn) {
    return selectByLang(optionCn, optionEn)
  }

  public getImageSource(size: string, path: string){
    return getImageSource(size, path)
  }

  public go() {
    this.timer = window.setInterval(() => {
      this.autoPlay();
    }, 4000);
  }

  public stop() {
    clearInterval(this.timer);
    this.timer = 0;
  }

  public change(index: number) {
    if (index < 0 || index > this.slideList.length - 1) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = index;
    }
  }

  public autoPlay() {
    if(this.slideList){
      this.currentIndex++;
      if (this.currentIndex > this.slideList.length - 1) {
        this.currentIndex = 0;
      }
    }
  }

  created() {
    this.$nextTick(() => {
      this.timer = window.setInterval(() => {
        this.autoPlay();
      }, 4000);
    });
  }
}
